import { extractDateTimeParts } from './extract-date-time-parts';

/**
 * Format a date with name for event selectors
 * Returns format: "Fri02 - Event Name"
 *
 * @example
 * formatDateName('My Event', 1706515200, 'Europe/Madrid', 'en')
 * // Returns: "Fri02 - My Event"
 */
export const formatDateName = (name: string, startingTime: number, timezone: string, locale: string = 'en') => {
  const parts = extractDateTimeParts(startingTime, locale, timezone, { dateStyle: 'veryShort' });
  return `${parts.weekday}${parts.day} - ${name}`;
};
